export const REPORTS_RECEIVER = 'REPORTS_RECEIVER';
export const GLOBAL_REPORTS_RECEIVER = 'GLOBAL_REPORTS_RECEIVER';
